import { call, fork, put, select, takeLatest } from 'redux-saga/effects';

import history from '../history';
import * as types from '../constants/actionTypes';
import actions from '../actions';
import api from '../lib/api';
import notify from '../lib/notify';
import { getProfileForm } from './selectors';

export function* fetchProfileOptionsSaga() {
  try {
    yield put(actions.profile.fetchProfileOptionsLoading());
    const data = yield call(api.profile.options);
    yield put(actions.validation.updateRules('profile', data));
    yield put(actions.profile.fetchProfileOptionsSuccess());
  } catch (e) {
    yield put(actions.profile.fetchProfileOptionsError());
    yield call(notify, e);
  }
}

export function* createProfileSaga() {
  try {
    const profileToCreate = yield select(getProfileForm);
    yield put(actions.profile.createProfileLoading());
    yield call(api.profile.create, profileToCreate);
    yield put(actions.profile.createProfileSuccess());
    yield put(actions.form.clearForm('profile'));
    history.push('/confirmation/signup');
  } catch (e) {
    yield put(actions.profile.createProfileError());
    yield call(notify, e);
  }
}

export function* uploadProfileImageSaga(action) {
  try {
    yield put(actions.form.uploadProfileImageLoading());
    yield call(notify, { type: 'info', title: 'Uploading image...' });
    const response = yield call(api.s3.putS3, action.mime, action.blob);
    yield put(actions.form.uploadProfileImageSuccess());
    yield call(notify, { type: 'success', title: 'Successfully uploaded image' });
    yield put(actions.form.updateField('profile', 'avatar', response.uri));
  } catch (e) {
    yield put(actions.form.uploadProfileImageError());
    yield call(notify, e);
  }
}

export function* watchFetchProfileOptionsSaga() {
  yield takeLatest(types.FETCH_PROFILE_OPTIONS, fetchProfileOptionsSaga);
}

export function* watchCreateProfileSaga() {
  yield takeLatest(types.CREATE_PROFILE, createProfileSaga);
}

export function* watchUploadProfileImageSaga() {
  yield takeLatest(types.UPLOAD_PROFILE_IMAGE, uploadProfileImageSaga);
}

export default [
  fork(watchFetchProfileOptionsSaga),
  fork(watchCreateProfileSaga),
  fork(watchUploadProfileImageSaga),
];
